import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useMe } from '../auth.tsx';

/**
 * Selo "Administrador" ao lado do logo, em todas as molduras: quem alterna entre a própria conta e
 * a de um usuário de teste sabe, de relance, com qual entrou. Só aparece para quem tem o grupo
 * Administrador do sistema (`isAdmin` de /auth/me). Na versão compacta (faixas estreitas, só com
 * o símbolo), fica só o ícone, com o nome na dica e para o leitor de tela. A cor é a de destaque
 * do tema (a mesma dos botões principais), que aparece tanto na lateral escura quanto na clara.
 */
export function AdminBadge({ compact = false }: { compact?: boolean }) {
  const { t } = useTranslation();
  const me = useMe();
  if (!me.data?.isAdmin) return null;
  const label = t('nav.adminBadge');
  if (compact)
    return (
      <span
        role="img"
        aria-label={label}
        title={label}
        className="flex size-7 shrink-0 items-center justify-center rounded-full bg-accent text-on-accent"
      >
        <ShieldCheck size={15} strokeWidth={2} aria-hidden />
      </span>
    );
  return (
    <span className="inline-flex shrink-0 items-center gap-1 self-start rounded-full bg-accent px-2 py-0.5 text-[11px] leading-4 font-semibold whitespace-nowrap text-on-accent">
      <ShieldCheck size={12} strokeWidth={2.25} aria-hidden />
      {label}
    </span>
  );
}
